module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('section', {
    staticClass: "tier section wrapper",
    class: [_vm.tier]
  }, [_h('div', {
    staticClass: "inner"
  }, [_h('h1', ["2. Class"]), " ", _h('form', {
    attrs: {
      "method": "post",
      "action": "#"
    }
  }, [_h('div', {
    staticClass: "row"
  }, [_h('div', {
    staticClass: "4u 12u$(small)"
  }, [_h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tier),
      expression: "tier"
    }],
    attrs: {
      "type": "radio",
      "id": "demo-priority-low",
      "name": "demo-priority",
      "value": "budget"
    },
    domProps: {
      "checked": _vm._q(_vm.tier, "budget")
    },
    on: {
      "change": function($event) {
        _vm.tier = "budget"
      }
    }
  }), " ", _h('label', {
    attrs: {
      "for": "demo-priority-low"
    }
  }, ["Budget"])]), " ", _h('div', {
    staticClass: "4u 12u$(small)"
  }, [_h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tier),
      expression: "tier"
    }],
    attrs: {
      "type": "radio",
      "id": "demo-priority-normal",
      "name": "demo-priority",
      "value": "turist"
    },
    domProps: {
      "checked": _vm._q(_vm.tier, "turist")
    },
    on: {
      "change": function($event) {
        _vm.tier = "turist"
      }
    }
  }), " ", _h('label', {
    attrs: {
      "for": "demo-priority-normal"
    }
  }, ["Turistic"])]), " ", _h('div', {
    staticClass: "4u$ 12u$(small)"
  }, [_h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tier),
      expression: "tier"
    }],
    attrs: {
      "type": "radio",
      "id": "demo-priority-high",
      "name": "demo-priority",
      "value": "confort"
    },
    domProps: {
      "checked": _vm._q(_vm.tier, "confort")
    },
    on: {
      "change": function($event) {
        _vm.tier = "confort"
      }
    }
  }), " ", _h('label', {
    attrs: {
      "for": "demo-priority-high"
    }
  }, ["Confort"])])]), " ", _h('transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [(_vm.tier == 'budget') ? _h('div', {
    key: "budget"
  }, [_h('h2', ["Up to 100€"]), " ", _h('p', ["Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto libero reiciendis, in est nulla assumenda ducimus et perspiciatis repellat voluptatem excepturi dicta laboriosam ea odit ullam, totam possimus dignissimos quo."])]) : _vm._e(), " ", (_vm.tier == 'turist') ? _h('div', {
    key: "turist"
  }, [_h('h2', ["Up to 300€"]), " ", _h('p', ["Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto libero reiciendis, in est nulla assumenda ducimus et perspiciatis repellat voluptatem excepturi dicta laboriosam ea odit ullam, totam possimus dignissimos quo."])]) : _vm._e(), " ", (_vm.tier == 'confort') ? _h('div', {
    key: "confort"
  }, [_h('h2', ["More than 300€"]), " ", _h('p', ["Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto libero reiciendis, in est nulla assumenda ducimus et perspiciatis repellat voluptatem excepturi dicta laboriosam ea odit ullam, totam possimus dignissimos quo."])]) : _vm._e()]), " ", _vm._m(0)]), " ", " "])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('ul', {
    staticClass: "actions"
  }, [_h('li', [_h('input', {
    attrs: {
      "type": "submit",
      "value": "Next"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-73b31a34!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tier.vue
// module id = 42
// module chunks = 1